/** Parâmetros para download de arquivo */
export interface DownloadFileParams {
  /** Nome do arquivo a ser salvo */
  fileName: string;
  /** Objeto File ou Blob com os dados */
  data: File | Blob;
}

/**
 * Cria um link temporário e dispara o download de um arquivo no browser.
 *
 * @param params - Nome e dados do arquivo a baixar
 */
export function downloadFile({ fileName, data }: DownloadFileParams): void {
  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
